import styled from "styled-components";

export const LandingContaner = styled.div`
  width: 100%;
  height: 100%;
  background: var(--color-primary-gradient);
`;

export const Body = styled.p`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  @media (max-width: 450px) {
    padding: 0 10px;
  }
`;

export const LogoImg = styled.img`
  width: 230px;
`;

export const Title = styled.p`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  max-width: 500px;
  text-align: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const Button = styled.button`
  background-color: var(--color-primary);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
  
  &:hover {
    background-color: var(--color-secondary);
  }
`;
